<template>
  <v-expansion-panel dark inset>
    <v-expansion-panel-content v-for="(item, index) in items" :key="index">
      <div slot="header">
        <h2>{{ item.lHeader }}</h2>
        <p>{{ item.rHeader }}</p>
        <p v-if="item.description">{{ item.description }}</p>
      </div>
      <v-list>
        <template v-for="lItem in item.tasks">
          <v-divider :key="lItem"></v-divider>
          <v-list-tile :key="lItem">
            <v-list-tile-content>
              <v-list-tile-title v-html="lItem"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "ResumeExperience",
  data() {
    return {
      items: [
        {
          lHeader: "Software Engineer at Holland & Hart LLP",
          rHeader: "April 2017 - January 2019",
          tasks: [
            "Created a centralized authentication microservice to streamline access control",
            "Developed tools for trademark attorneys to quickly analyze and respond to USPTO correspondence",
            "Designed and built the backend for an office suite plugin designed to deliver timekeeping functionality to users",
            "Integrated applications with third party APIs using REST and SOAP",
            "Implimented a secure tunnel to communicate between cloud infrastructure and private datacenter",
            "Secured several web applications in accordance with OWASP guidlines",
            "Established a Kubernetes cluster both in MS Azure and private data center",
            "Prepared microservices for migration into a Kubernetes cluster using Docker"
          ],
          description:
            "While working at Holland & Hart I primarily developed backend microservices to support our many web apps and email-based automations. In addition I provided infrastructure support for our virtualized resources as well as those hosted within Kubernetes on Microsoft's Azure cloud platform. Working with users regularly to determine their needs and responding quickly to provide solutions was one of the highlights of my role. Some specific examples of responsibilites are",
          link: ""
        },
        {
          lHeader: "VLSI Engineer I at Seagate Technology LLC",
          rHeader: "May 2016 - April 2017",
          tasks: [
            "Designed and ran random, constrained tests of simulated integrated circuits",
            "Designed and created UVM compliant test bench with reusable test components",
            "Collaborated with team members located around the globe"
          ],
          description:
            "While working at Seagate I worked on a team responsible for designing application specific integrated circuits which were shipped in millions of drives. The work I did centered around both the creation of new circuitry using System Verilog as well as rigorous testing to verify that components functioned properly.",
          link: ""
        },
        {
          lHeader: "VLSI Engineer Intern at Seagate Technology LLC",
          rHeader: "May 2015 - August 2015",
          tasks: [
            "Designed and built a system to automate the running of verification tests",
            "Wrote Python scripts to automatically collect data from simulations",
            "Interfaced Python scripts with Google Docs using GDocs API"
          ],
          description:
            "During my summer internship at Seagate I was tasked with simplifying the process of running, recording, and reporting the results of verification testing data for my team. This involved the orchestration of several different programs as well as integration with systems used to aggregate the results of the tests.",
          link: ""
        },
        {
          lHeader:
            "Linux System Administrator at University of Colorado Boulder",
          rHeader: "August 2014 - May 2015",
          tasks: [
            "Maintained multiple linux servers with thousands of users",
            "Provided both remote and on site support for software and hardware",
            "Wrote shell and Ruby scripts to automate maintenance tasks"
          ],
          description:
            "While working at CU Boulder on the Unix Ops team I worked on a team with others to provide support for many Linux servers as well as supporting user machines. We had a variety of administration tasks from log monitoring to user access management. There were many tasks automated using scripts written in Bash, Ruby, and Python.",
          link: ""
        }
      ]
    };
  }
};
</script>

<style scoped></style>
